<section class="cl-section cl-section-regular">
  <div class="container">
    <div class="row mb-4">
      <div class="col-12">

        <p class="alert cl-alert-action">
          @if ('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: ('contentplatform:asset:input.folder_id/' + (folderSubject | async).id): organization()) {
            <a role="button" [processButton]="'generate-preview-' + (folderSubject | async).id"
            (click)="generatePreview()">Generate preview</a>
            <a role="button" [processButton]="'force-preview-' + (folderSubject | async).id"
            (click)="generatePreview(true)">Force preview</a>
          }
          @if ('contentplatform:repository:Mutation/CreateUploadTicket' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id: organization()) {
            <a role="button"
            (click)="generateUploadLink()">Upload files</a>
          }
          @if (this.poMetaService.poService?.action | isAllowed: 'contentplatform:asset:input.input_brefix/' + ((folderSubject | async).id | remove: 's3://'): organization()) {
            <a role="button"
            (click)="addToPo()">Add to PO</a>
          }
          @if (this.poMetaService.poService?.action | isAllowed: 'contentplatform:asset:input.content_identifier/s3://' + ((folderSubject | async).id | remove: 's3://'): organization()) {
            <a role="button"
            (click)="addToPo()">Add to PO</a>
          }
          <a role="button" (click)="viewAsListing()">View as Listing</a>
          <app-s3-link style="margin-left: 16px" [fof]="this.folderSubject.value"></app-s3-link>
        </p>
      </div>
      @if (previewTokenPayload) {
        <div class="col-12">
          <app-mezz-preview-player [manifest]="previewTokenPayload.dash_url"
            [drmtodayToken]="previewTokenPayload.drmtoday_token"
            [accessToken]="previewTokenPayload.access_token"
            [selectedVideoFileTrack]="selectedVideoFileTrack"
            [selectedAudioFileTrack]="selectedAudioFileTrack"
            [selectedTextFileTrack]="selectedTextFileTrack"
            >
          </app-mezz-preview-player>
        </div>
      }
    </div>
    @if (loadError()) {
      <p role="alert">Could not load the asset details: {{ loadError() }}</p>
    }
    @if (!loading()) {
      <section class="cl-section cl-section-form cl-color-haze it-asset-form" data-edge-haze>
      @if (videoTracks.length > 0) {
        <div class="row">
          <div class="col-12">
            <div class="cl-h3">Video</div>
            <p>Video tracks found in the files of this folder. Active tracks are the ones used for this content;
              clear Active to leave a track out. Once a preview is generated, select a track to show it in the
              player.</p>
          </div>
          <div class="col-12">
            <table class="cl-table-data cl-form">
              <thead>
                <tr>
                  @if ('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id: organization()) {
                    <th class="cl-table-head cl-th-checkbox"></th>
                  }
                  <th class="cl-table-head">File</th>
                  <th class="cl-table-head">Track</th>
                  <th class="cl-table-head cl-th-checkbox">Active</th>
                </tr>
              </thead>
              <tbody>
                @for (v of videoTracks; track v) {
                  <tr>
                    @if ('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id : organization()) {
                      <td class="cl-td-checkbox">
                        <div class="form-check">
                          <input [disabled]="!previewTokenPayload" type="radio" name="video" class="form-check-input"
                            [checked]="selectedVideoFileTrack?.file.name === v.file.name && selectedVideoFileTrack?.track.index === v.track.index"
                            (change)="this.selectedVideoFileTrack = v">
                        </div>
                      </td>
                    }
                    <td class=""><a [routerLink]="v.file |link ">{{ v.file.name }}</a></td>
                    <td>{{ v.track.index }}</td>
                    <td class="cl-td-checkbox">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="switch-1" [(ngModel)]="v.track.enabled"
                          [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (audioTracks.length > 0) {
          <div class="row">
            <div class="col-12">
              <div class="cl-h3">Audio</div>
              <p>Audio tracks found in the files of this folder. Layout is the channel layout read from the file,
                and a warning marks tracks that are not stereo. Set the language for each track, and clear Active
                to leave a track out. Once a preview is generated, select a track to play it in the player.</p>
            </div>
            <div class="col-12">
              <table class="cl-table-data cl-form">
                <thead>
                  <tr>
                    @if ('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id: organization()) {
                      <th class="cl-table-head cl-th-checkbox"></th>
                    }
                    <th class="cl-table-head">File</th>
                    <th class="cl-table-head">Track</th>
                    <th class="cl-table-head">Layout</th>
                    <th class="cl-table-head">Language</th>
                    <th class="cl-table-head cl-th-checkbox">Active</th>
                  </tr>
                </thead>
                <tbody>
                  @for (v of audioTracks; track v; let i = $index) {
                    <tr>
                      @if ('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id:organization()) {
                        <td class="cl-td-checkbox">
                        <div class="form-check">
                          <input [disabled]="!previewTokenPayload" type="radio" name="audio" class="form-check-input"
                            [checked]="selectedAudioFileTrack?.file.name === v.file.name && selectedAudioFileTrack?.track.index === v.track.index"
                            (change)="this.selectedAudioFileTrack = v">
                        </div>
                      </td>
                    }
                    <td class=""><a [routerLink]="v.file |link ">{{ v.file.name }}</a></td>
                    <td>{{ v.track.index }}</td>
                    <td>{{ v.channelLayout }} @if (v.channelWarn) {
                      <i class="fa fa-exclamation-triangle"></i>
                    }</td>
                    <td>
                      <select class="form-select cl-field-sans d-lg-none" [(ngModel)]="v.track.language"
                        [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                        @for (l of languages; track l) {
                          <option [value]="l.id">{{ l.id }}</option>
                        }
                      </select>
                      <select class="form-select cl-field-sans d-none d-lg-block" [(ngModel)]="v.track.language"
                        [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                        @for (l of languages; track l) {
                          <option [value]="l.id">{{ l.name }}</option>
                        }
                      </select>
                    </td>
                    <td class="cl-td-checkbox">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="v.track.enabled"
                          [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (textTracks.length > 0) {
          <div class="row">
            <div class="col-12">
              <div class="cl-h3">Text</div>
              <p>Subtitle and closed-caption tracks found in the files of this folder. Set the type and language
                for each track, and clear Active to leave a track out. An icon beside a file name means QC found
                issues. Once a preview is generated, select a track to show it in the player, or No Text Track to
                show none.</p>
            </div>
            <div class="col-12">
              <table class="cl-table-data cl-form">
                <thead>
                  <tr>
                    @if ('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id: organization()) {
                      <th class="cl-table-head cl-th-checkbox"></th>
                    }
                    <th class="cl-table-head">File</th>
                    <th class="cl-table-head">Tr.</th>
                    <th class="cl-table-head">Type</th>
                    <th class="cl-table-head">Language</th>
                    <th class="cl-table-head cl-th-checkbox">Active</th>
                  </tr>
                </thead>
                <tbody>
                  @if (('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id : organization()) && previewTokenPayload) {
                    <tr
                      >
                    <td class="cl-td-checkbox">
                      <div class="form-check">
                        <input [disabled]="!previewTokenPayload" type="radio" name="text" class="form-check-input"
                          [checked]="selectedTextFileTrack === null"
                          (change)="this.selectedTextFileTrack = null">
                      </div>
                    </td>
                    <td class="">No Text Track</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="cl-td-checkbox"></td>
                  </tr>
                }
                @for (v of textTracks; track v) {
                  <tr>
                    @if ('contentplatform:repository:Mutation/PreviewGenerate' | isAllowed: 'contentplatform:asset:input.folder_id/' + (folderSubject | async).id: organization()) {
                      <td class="cl-td-checkbox">
                        <div class="form-check">
                          <input [disabled]="!previewTokenPayload" type="radio" name="text" class="form-check-input"
                            [checked]="selectedTextFileTrack?.file.name === v.file.name && selectedTextFileTrack?.track.index === v.track.index"
                            (change)="this.selectedTextFileTrack = v">
                        </div>
                      </td>
                    }
                    <td class="">
                      <a [routerLink]="v.file |link ">{{ v.file.name }}</a>
                      @if (v.criticalQc) {
                        <span class="cl-color-text-brick" style="margin-left: 6px"
                              appTooltip="Has critical QC errors — encode may fail">
                          <i class="fas fa-exclamation-circle"></i>
                        </span>
                      }
                      @if (v.warningQc && !v.criticalQc) {
                        <span class="cl-color-text-honey" style="margin-left: 6px"
                              appTooltip="Has auto QC warnings">
                          <i class="fas fa-exclamation-triangle"></i>
                        </span>
                      }
                    </td>
                    <td>{{ v.track.index }}</td>
                    <td>
                      <select class="form-select cl-field-sans" [(ngModel)]="v.track.track_type"
                        [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                        <option [value]="TrackType.Closedcaption">CC</option>
                        <option [value]="TrackType.Subtitle">Subs</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-select cl-field-sans" [(ngModel)]="v.track.language"
                        [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                        @for (l of languages; track l) {
                          <option [value]="l.id">{{ l.name }}</option>
                        }
                      </select>
                    </td>
                    <td class="cl-td-checkbox">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="v.track.enabled"
                          [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (imageTracks.length > 0) {
          <div class="row">
            <div class="col-12">
              <div class="cl-h3">Images</div>
              <p>Images found in the files of this folder, such as artwork or stills. Active images are the ones
                used for this content; clear Active to leave an image out.</p>
            </div>
            <div class="col-12">
              <table class="cl-table-data cl-form">
                <thead>
                  <tr>
                    <th class="cl-table-head">File</th>
                    <th class="cl-table-head cl-th-checkbox">Active</th>
                  </tr>
                </thead>
                <tbody>
                  @for (v of imageTracks; track v) {
                    <tr>
                      <td class=""><a [routerLink]="v.file |link ">{{ v.file.name }}</a></td>
                      <td class="cl-td-checkbox">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" [(ngModel)]="v.track.enabled"
                            [disabled]="!('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + v.file.id: organization())">
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          @let canTag = 'contentplatform:repository:Mutation/TagFolder' | isAllowed: 'contentplatform:folder:input.folder_id/' + (folderSubject | async).id: organization();
          <div class="row">
            <div class="col-12">
              <div class="cl-h3">Tags</div>
            </div>
            <div class="col-12 col-md-9">
              <p>Custom key–value labels that describe this folder.</p>
            </div>
            <div class="col-12 col-md-3">
              @if (canTag) {
                <div class="cl-flex-center-center">
                  <button (click)="openAddTag()" class="btn btn-sm cl-color-secondary it-tag-add" type="button">Add tag</button>
                </div>
              }
            </div>
            <div class="col-12 cl-form">
              <div class="cl-table-scroll">
                <table class="cl-table-data cl-table-nonresponsive it-tags">
                  <thead>
                    <tr>
                      <th class="cl-table-head">Key</th>
                      <th class="cl-table-head">Value</th>
                      @if (canTag) {
                        <th class="cl-table-head cl-th-links"></th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (tag of tags; track tag; let i = $index) {
                      <tr class="it-tag-row">
                        <td class="it-tag-key">{{ tag.key }}</td>
                        <td class="it-tag-value">{{ tag.value }}</td>
                        @if (canTag) {
                          <td class="cl-td-links" width="1%">
                            <a (click)="editTag(i)" (keydown.enter)="editTag(i)" (keydown.space)="$event.preventDefault(); editTag(i)" [attr.aria-label]="'Edit tag ' + tag.key" class="cl-a-btn cl-a-primary it-tag-edit" role="button" tabindex="0">Edit</a>
                            <a (click)="removeTag(i)" (keydown.enter)="removeTag(i)" (keydown.space)="$event.preventDefault(); removeTag(i)" [attr.aria-label]="'Delete tag ' + tag.key" class="cl-a-btn it-tag-delete" role="button" tabindex="0">Delete</a>
                          </td>
                        }
                      </tr>
                    } @empty {
                      <tr class="cl-tr-no-data"><td colspan="100">No tags available.</td></tr>
                    }
                  </tbody>
                </table>
              </div>
              @let duplicates = duplicateTagKeys;
              @if (duplicates.length > 0) {
                <p class="invalid-feedback d-block it-tags-duplicate-keys">
                  Each key can be used only once. Used more than once: {{ duplicates.join(', ') }}.
                  Edit or delete the extra tags, then save again.
                </p>
              }
            </div>
          </div>
          </section>
          @if ('contentplatform:repository:Mutation/UpdateFile'| isAllowed: 'contentplatform:file:input.file_id/' + (folderSubject | async).id: organization()) {
            <div class="row">
              <div class="col-12">
                <app-form-footer label="Save changes" icon="save" (action)="save_changes($event)"></app-form-footer>
              </div>
            </div>
          }
        } @else if (!loadError()) {
          <div class="col-12 d-flex justify-content-center align-items-center" style="height: 40vh;">
            <div class="cl-spinner">Loading ...</div>
          </div>
        }
      </div>

    </section>
